import { useState } from "react";
import { AiOutlineLink } from "react-icons/ai";
import { IoCreateOutline } from "react-icons/io5";
import * as yup from "yup";
import { useSeller } from "../../providers/users";
import Loading from "../Loading";
import { Container } from "./styles";

import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useProduct } from "../../providers/products";
import { useTranslation } from "react-i18next";
import PageHeader from "../pageHeader";
const ProductCreationForm = () => {
  const { apiLoading } = useSeller();
  const { createProduct } = useProduct();
  const navigate = useNavigate();
  const [language, setLanguage] = useState("english");
  const [file, setFile] = useState<File | null>(null);
  const { path } = useParams();
  const { t } = useTranslation();

  const handleChange = (event: any) => {
    setLanguage(event.target.value);
  };
  type FormValues = yup.InferType<typeof formSchema>;
  const onSubmit = async (data: FormValues) => {
    setFile(null);
    await createProduct(data);
  };

  const handleFileUpload = (e: any) => {
    if (!e.target.files) {
      return;
    }
    const file = e.target.files[0];
    setFile(file);
  };
  const formSchema = yup
    .object()
    .shape({
      name: yup.string().required(t("name_required")).max(128, t("name_max")),
      description: yup
        .string()
        .required(t("description_required"))
        .max(128, t("description_max")),
      //   fileInput: yup
      //     .mixed()
      //     .required(t("file_required"))
      //     .test("fileSize", t("file_size"), (value) => {
      //       return value && value[0].size <= 1000 * 1024 * 1024;
      //     })
      //     .test(
      //       "type",
      //       t("file_accept", { file_types: ".jpeg, .jpg, .gif, .png" }),
      //       (value) => {
      //         return (
      //           value &&
      //           (value[0].type === "image/jpg" ||
      //             value[0].type === "image/jpeg" ||
      //             value[0].type === "image/gif" ||
      //             value[0].type === "image/png")
      //         );
      //       }
      //     ),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  return (
    <Container>
      <PageHeader
        title={t("new_product")}
        description={`${t("fill_create")} ${t("product")}`}
        icon={<IoCreateOutline />}
      />

      <form onSubmit={handleSubmit(onSubmit)}>
        <TextField
          error={errors.name === undefined ? false : true}
          helperText={errors.name?.message?.toString()}
          id="standard-name"
          label={t("name")}
          variant="standard"
          {...register("name")}
        />
        <TextField
          id="standard-description"
          error={errors.description === undefined ? false : true}
          helperText={errors.description?.message?.toString()}
          label={t("description")}
          variant="standard"
          {...register("description")}
        />

        <Button
          component="label"
          variant="outlined"
          startIcon={<AiOutlineLink />}
        >
          Upload Image
          <input
            {...register("fileInput")}
            className="inputNone"
            type="file"
            accept=".png, .jpg, .jpeg, .gif"
            required
            onInput={handleFileUpload}
          />
        </Button>
        <p className="errosForm">
          {errors.fileInput && errors.fileInput.message?.toString()}
        </p>
        <Box>{file?.name}</Box>

        <FormControl>
          <InputLabel id="demo-simple-select-label">{t("language")}</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={language}
            label={t("language")}
            {...register("language")}
            onChange={handleChange}
          >
            <MenuItem value={"english"}>{t("english")}</MenuItem>
            <MenuItem value={"portuguese"}>{t("portuguese")}</MenuItem>
          </Select>
        </FormControl>
        {apiLoading ? (
          <Loading />
        ) : (
          <div>
            <Button type="submit" variant="contained">
              {t("create")}
            </Button>
            <Button
              sx={{ ml: 1 }}
              onClick={() => navigate("/" + path + "/products")}
              variant="outlined"
            >
              {t("cancel")}
            </Button>
          </div>
        )}
      </form>
    </Container>
  );
};

export default ProductCreationForm;
